import { render } from "./ToDoTask.vue?vue&type=template&id=4dc703d4&scoped=true"
import script from "./ToDoTask.vue?vue&type=script&lang=js"
export * from "./ToDoTask.vue?vue&type=script&lang=js"

import "./ToDoTask.vue?vue&type=style&index=0&id=4dc703d4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc703d4"]])

export default __exports__